import { QuoteList } from "src/api-service";

// **************************************************************************
// REVIEW QUOTES STATE
// **************************************************************************
export interface ReviewQuotesState {
    quotes: QuoteList[] | undefined;
    loaded: boolean;
    loading: boolean;
}

export const initialReviewQuotesState: ReviewQuotesState = {
    quotes: undefined,
    loaded: false,
    loading: false,
};
